<template>
<svg width="22" height="19" viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.9203 8.24892L13.5071 7.60757L13.084 8.24237L9.98603 12.8896L7.90703 9.97555L7.48649 9.38612L7.08425 9.98818L3.58425 15.2269L3.06462 16.0047H4H18H18.9169L18.4203 15.2339L13.9203 8.24892ZM4.93538 15.0047L7.5135 11.1458L9.59297 14.0605L10.014 14.6505L10.416 14.0474L13.4929 9.43185L17.0831 15.0047H4.93538ZM2 0.870605H20C20.7552 0.870605 21.5 1.62048 21.5 2.69892V16.6688C21.5 17.7473 20.7552 18.4971 20 18.4971H2C1.24475 18.4971 0.5 17.7473 0.5 16.6688V2.69892C0.5 1.62048 1.24475 0.870605 2 0.870605Z" stroke="white"/>
</svg>
</template>
<script>
export default {}
</script>